import Modal from "react-modal"
import {
    ButtonClass,
    LightGrayButtonClass,
    modalStyles
} from "contexts/style"
import React, { useEffect, useState } from "react"
import showMessage from "./showMessage"
import useBookingsMutations from "database/useBookingsMutations"
import { checkPetTime, getIvTime, isPet, OUTER_BOOK_TYPE, PRE_BOOK_STATUS } from "contexts/enviroments"
import { FormTmpPatients } from "./FormTmpPatient"
import usePatientsMutations from "database/usePatientsMutations"
import { getSequenceNo } from "database/useSequenceFindOneAndUpdate";
import { getCheckinTime } from "contexts/functions";

import { Loading } from "./Loading"
import { useFindBookings, useMongoQueryDirect } from "contexts/useMongoQuery"
import { useFirebaseApp } from "contexts/FirebaseApp"
import { useNavigate } from "react-router-dom"
import { useExternalBookDate } from "contexts/ExternalBookDateContext"
import { sendPreFixToExternal, sendPreFixToInternal } from "mail/sendPreFix"
import { convertDate } from "contexts/functions"
import { RECEPTION_DUR } from "contexts/enviroments"

export const ExternalEntryForm = ({ isModalOpen, setIsModalOpen, modality, date, duration }:
    { isModalOpen: boolean, setIsModalOpen: any, modality: KV[], date: Date, duration: number[] }) => {
    // Modalityの開始終了時刻(セット含む)
    const [start, setStart] = useState(new Date())
    const [end, setEnd] = useState(new Date())
    const [start2, setStart2] = useState(new Date())
    const [end2, setEnd2] = useState(new Date())

    const [patientName, setPatientName] = useState<string>("")
    const [patientNameKana, setPatientKana] = useState<string>("")
    const [tel, setTel] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { currentUser, functions } = useFirebaseApp()
    const { addPatient } = usePatientsMutations()
    const { addBooking } = useBookingsMutations()
    const [hasIv, setHasIv] = useState<boolean>(false)
    const [ivStart, setIvStart] = useState(new Date())
    const [ivEnd, setIvEnd] = useState(new Date())

    const navigate = useNavigate()
    const { externalBookDate, setExternalBookDate } = useExternalBookDate()

    const tmpDate = new Date(date)
    tmpDate.setHours(0, 0, 0, 0)
    const dateRange = { start: tmpDate, end: tmpDate }

    const { loading, data: events } = useFindBookings(dateRange)
    const query = useMongoQueryDirect();

    // Closeボタン
    const resetStates = () => {
        setIsModalOpen(false)
        setPatientName('')
        setPatientKana('')
        setTel('')
        setIsLoading(false)
        setHasIv(false)
    }

    // Date型をhour:minuteに変換
    const convertDate2Time = (_date: Date) => {
        const hour = String(_date.getHours()).padStart(2, '0')
        const minute = String(_date.getMinutes()).padStart(2, '0')

        return `${hour}:${minute}`
    }

    // 受付時刻を設定
    const getReceptionDateTime = () => {
        const hour = String(date.getHours()).padStart(2, '0')
        const minute = String(date.getMinutes()).padStart(2, '0')

        return `${hour}:${minute}`
    }

    // 検査開始時刻
    const getStartTime = (index: number) => {
        let hour = ""
        let minute = ""
        if (index === 0) {
            hour = String(start.getHours()).padStart(2, '0')
            minute = String(start.getMinutes()).padStart(2, '0')
        } else {
            hour = String(start2.getHours()).padStart(2, '0')
            minute = String(start2.getMinutes()).padStart(2, '0')
        }
        return `${hour}:${minute}`
    }

    // 検査終了時刻
    const getEndTime = (index: number) => {
        let hour = ""
        let minute = ""
        if (index === 0) {
            hour = String(end.getHours()).padStart(2, '0')
            minute = String(end.getMinutes()).padStart(2, '0')
        } else {
            hour = String(end2.getHours()).padStart(2, '0')
            minute = String(end2.getMinutes()).padStart(2, '0')
        }
        return `${hour}:${minute}`
    }

    // 予約当日
    const getDate = () => {
        const newDate = new Date(date)
        const year = newDate.getFullYear()
        const month = String(newDate.getMonth() + 1).padStart(2, '0')
        const day = String(newDate.getDate()).padStart(2, '0')
        return `${year}年${month}月${day}日`
    }

    // モーダルオープン時にstart / endを設定
    useEffect(() => {
        const fetchModalOpen = async () => {
            const baseDate = new Date(date)
            const startDate = new Date(date)
            const endDate = new Date(date)
            const startDate2 = new Date(date)
            const endDate2 = new Date(date)
            const ivstart = new Date(date)
            const ivend = new Date(date)

            // 時刻設定
            if (modality[0].ID === 'MRI') {
                startDate.setMinutes(baseDate.getMinutes() + RECEPTION_DUR)
                endDate.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + duration[0])

                // セット予約の場合
                if (modality.length === 2) {
                    if (modality[1].ID === 'MRI') {
                        startDate2.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + duration[0])
                        endDate2.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + duration[0] + duration[1])
                    } else {
                        // IV時間を計算
                        const iv_time = await getIvTime(modality[1].ID, modality[1].body1, modality[1].body2)
                        startDate2.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + duration[0] + iv_time)
                        endDate2.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + duration[0] + iv_time + duration[1])
                        if (iv_time > 0) {
                            setHasIv(true)
                            ivstart.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + duration[0])
                            setIvStart(ivstart)
                            ivend.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + duration[0] + 10)
                            setIvEnd(ivend)
                        } else {
                            setHasIv(false)
                        }
                    }
                }
            } else {
                // IV時間を計算, 準備は20分とする
                const iv_time = await getIvTime(modality[0].ID, modality[0].body1, modality[0].body2)
                startDate.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + iv_time)
                endDate.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + iv_time + duration[0])

                if (iv_time > 0) {
                    setHasIv(true)
                    ivstart.setMinutes(baseDate.getMinutes() + RECEPTION_DUR)
                    setIvStart(ivstart)
                    ivend.setMinutes(baseDate.getMinutes() + RECEPTION_DUR + 10)
                    setIvEnd(ivend)
                } else {
                    setHasIv(false)
                }


                // セット予約の場合 IVは一回のみ
                if (modality.length === 2) {
                    startDate2.setMinutes(baseDate.getMinutes() + iv_time + RECEPTION_DUR + duration[0])
                    endDate2.setMinutes(baseDate.getMinutes() + iv_time + RECEPTION_DUR + duration[0] + duration[1])
                }
            }

            setStart(startDate)
            setEnd(endDate)
            setStart2(startDate2)
            setEnd2(endDate2)
        }
        fetchModalOpen()
    }, [isModalOpen])

    const receptMessage = (messages: any[]) => {
        const formattedMessages = messages.map((message) => {
            return `受付No.${message.seqNo} (モダリティ: ${message.modality})`;
        });
        return formattedMessages.join('\n');
    };

    // 予約データ投入
    const insertBooking = async () => {
        if (patientNameKana === '') {
            alert('患者名カナを入力してください')
            return
        }
        if (!await showMessage(`検査を予約しますか？`, { confirm: true })) {
            return
        }
        setIsLoading(true)

        try {
            // 仮患者IDの発番
            const getTmpPatientId = (min: number, max: number) => {
                return Math.floor(Math.random() * (max + 1 - min)) + min
            }
            const patientId = getTmpPatientId(1000000000, 9000000000).toString()

            const tmpPatient: Patient = {
                patientId: patientId,
                isTemp: true,
                name: patientName,
                nameKana: patientNameKana,
                birthDate: new Date(),
                gender: "",
                tel: tel,
            }
            await addPatient(tmpPatient)

            // 予約番号(アクセッション番号)発行
            let seqNos = []
            for (const item of modality) {
                const seqNo = await getSequenceNo(functions)
                if (!seqNo) {
                    alert('予約番号の発番に失敗しました。管理者へお問合せください。')
                    return false
                }
                seqNos.push(seqNo)
            }

            // @ts-ignore ログインIDからクリニック情報を取得
            const clinic_data = await functions(["mongo/client", {
                collection: "user", aggregate: [
                    {
                        $match: { _id: currentUser?.uid }
                    },
                    {
                        $lookup: {
                            from: "clinics",
                            localField: "clinic",
                            foreignField: "_id",
                            as: "clinic_info"
                        }
                    },
                    {
                        $unwind: "$clinic_info"
                    },
                    {
                        $project: {
                            clinic_id: "$clinic_info._id",
                            clinic_name: "$clinic_info.clinic_name",
                            departments: "$clinic_info.departments",
                            user_name: "$name",
                            user_id: "$_id"
                        }
                    }
                ]
            }]);
            // 空白を削除したログインユーザー
            const loginUser = (clinic_data as KV[])[0].user_name.replace(/\s/g, '')
            // nameが空白、doctorsの登録がない場合は削除
            const filteredDepartments = (clinic_data as KV[])[0].departments.filter((department: { name: string; doctors?: string[] }) => department.name !== "" || (department.doctors && department.doctors.length > 0));


            // 所属情報(医師名、診療科を取得)
            const foundEntry = filteredDepartments.map((department: { doctors: string[], name: string }) => {
                const foundDoctor = department.doctors.find(doctor => doctor.replace(/[\s*]/g, '') === loginUser)
                if (foundDoctor) {
                    return { doctor: foundDoctor?.replace(/\*+$/, ""), department: department.name }
                }
                return null
            }).filter((entry: KV) => entry !== null)[0]

            if (foundEntry) {
                let emailModalities = []
                let hospitals: any = {}
                let messages: any[] = []

                // --- 事前に seqNo を全部発行 ---
                const seqNos: string[] = [];
                for (const _ of modality) {
                    const seqNo = await getSequenceNo(functions);
                    if (!seqNo) {
                        alert('予約番号の発番に失敗しました。管理者へお問合せください。');
                        return false;
                    }
                    seqNos.push(String(seqNo));
                }
                const visitId = String(seqNos[0]);
                const bookingIDs: string[] = [];
                let firstBookingForVisit: Booking | null = null;
                let latestEnd: Date | null = null;

                for (let index = 0; index < modality.length; index++) {
                    const item = modality[index];
                    const seqNo = seqNos[index];

                    const booking: Booking = {
                        _id: String(seqNo),
                        visitID: visitId,
                        modalityID: item.ID,
                        body1: item.body1,
                        body2: item.body2,
                        contrast: item.contrast,
                        delay: false,
                        clinicID: (clinic_data as KV[])[0].clinic_id?.toString(),
                        clinicName: (clinic_data as KV[])[0].clinic_name,
                        doctor: foundEntry.doctor,
                        department: foundEntry.department,
                        bookingType: OUTER_BOOK_TYPE,
                        bookingMethod: 1,
                        checkin: getReceptionDateTime(),
                        patientID: patientId,
                        patient: patientId,
                        patientName: patientNameKana,
                        userID: currentUser?.uid,
                        doctorID: currentUser?.uid,
                        bookingStatus: PRE_BOOK_STATUS,
                        comment: '',
                        updated: new Date(),
                        created: new Date(),
                        start: index === 0 ? start : start2,
                        end: index === 0 ? end : end2,
                    };

                    // PET の IV 時間
                    if (isPet(booking)) {
                        const iv = await checkPetTime({ booking, events, query });
                        booking.ivCheckin = iv?.ivCheckin;
                    }

                    await addBooking(booking);
                    bookingIDs.push(String(booking._id));

                    const modalityForEmail: any = {
                        execTimeRange: `${convertDate2Time(booking.start as Date)} ~ ${convertDate2Time(booking.end as Date)}`,
                        id: item.ID,
                        body2: item.body2,
                        contrast: item.contrast,
                        seqNo,
                    };
                    emailModalities.push(modalityForEmail);

                    hospitals["clinic_name"] = (clinic_data as KV[])[0].clinic_name;
                    hospitals["doctor_name"] = foundEntry.doctor;
                    hospitals["department"] = foundEntry.department;

                    if (!firstBookingForVisit) firstBookingForVisit = booking;
                    if (!latestEnd || (booking.end && booking.end > latestEnd)) latestEnd = booking.end ?? null;
                }

                // --- 問診（外注）も同じ visitId をセット ---
                const seqNoExam = await getSequenceNo(functions);
                const bookingExam: Booking = {
                    _id: String(seqNoExam),
                    visitID: visitId,
                    modalityID: 'OUTEXAM',
                    body1: '',
                    body2: '',
                    contrast: '',
                    start: new Date(start),
                    end: new Date(end),
                    bookingType: OUTER_BOOK_TYPE,
                    bookingMethod: 1,
                    interviewType: '問診(外注)',
                    appointmentMethod: '来院',
                    bookingStatus: PRE_BOOK_STATUS,
                    updated: new Date(),
                    created: new Date(),
                };
                const [hh, mm] = firstBookingForVisit?.checkin?.split(':').map(Number) ?? [];
                bookingExam.start!.setHours(hh); bookingExam.start!.setMinutes(mm);
                bookingExam.end!.setHours(hh); bookingExam.end!.setMinutes(mm + 5);

                await functions(["mongo/client", { collection: "bookings", insertOne: { doc: bookingExam } }]);
                bookingIDs.push(String(seqNoExam));

                // --- visit 作成（ID は visitId を採用） ---
                if (!firstBookingForVisit) throw new Error("bookingが1件も作成されていません。");
                const visitStart = getCheckinTime(firstBookingForVisit.start!, firstBookingForVisit.checkin!);
                const visitEnd = latestEnd ?? firstBookingForVisit.end!;

                const visit: Visit = {
                    _id: visitId,
                    bookingType: OUTER_BOOK_TYPE,
                    clinicID: firstBookingForVisit.clinicID,
                    clinicName: firstBookingForVisit.clinicName,
                    comment: '',
                    department: firstBookingForVisit.department,
                    doctor: firstBookingForVisit.doctor,
                    start: visitStart,
                    end: visitEnd,
                    bookingIDs,
                    files: [],
                    patient: firstBookingForVisit.patient,
                    patientName: patientNameKana ?? firstBookingForVisit.patientName,
                    updated: new Date(),
                };

                await functions(["mongo/client", { collection: "visits", insertOne: { doc: visit } }]);

                await showMessage(`仮予約完了しました。\r\n${receptMessage(messages)}\r\n診療情報提供書のFAXを受理後、予約が確定となります。`, { keep: true })

                // Mail項目の整理
                const toExternals: string[] = []
                const toInternals: string[] = []
                const seqNosString = seqNos.join(', ')

                // ログインしているユーザーに通知
                if (currentUser?.email) {
                    toExternals.push(currentUser?.email)
                }
                // 院内(通知設定しているユーザー)
                const internal = await functions(["mongo/client", { collection: "user", find: { filter: { internal: true, notice: true } } }]) as KV[];
                if (internal && Array.isArray(internal)) {
                    internal.forEach((user: KV) => {
                        toInternals.push(user.email);
                    });
                }
                const params: KV = {
                    doctor: foundEntry.doctor,
                    bookNo: seqNosString,
                    bookDate: convertDate(start),
                    receptTime: getReceptionDateTime(),
                    patientNameKana: patientNameKana,

                }

                await sendPreFixToExternal(functions, toExternals, params, emailModalities)
                await sendPreFixToInternal(functions, toInternals, params, emailModalities, hospitals)

                // リダイレクト
                setExternalBookDate(start)
                navigate("/external/list")

            } else {
                await showMessage('ログインしたユーザーが不正です。管理者へ問い合わせてください。', { error: true, keep: true })
            }

        } catch (e) {
            if (e instanceof Error) await showMessage(`外部予約の登録ができませんでした。\r\nお手数ですが、もう一度お試しください。`, { error: true })
            return false
        } finally {
            setIsLoading(false)
            resetStates()
        }

    }

    const trimPET = (str: string) => {
        const regex = /_(1|2)$/
        const match = str.match(regex)

        if (match) {
            const convertedStr = str.replace(match[0], "")
            return convertedStr
        } else {
            return str
        }
    }

    return <>
        {isLoading && <Loading full />}
        <Modal
            isOpen={isModalOpen}
            ariaHideApp={false}
            style={modalStyles}
            contentLabel="External Opening Modal"
            shouldCloseOnOverlayClick={false}
        >
            <div>
                <div className="text-white text-3xl">検査日時：{getDate()}</div>
                <div className="w-8/12">
                    <div className="text-white text-2xl mt-5">検査内容</div>
                    <table className="min-w-full table-auto border-collapse border">
                        <thead>
                            <tr className="border">
                                <th className="border px-4 py-2">モダリティ</th>
                                <th className="border px-4 py-2">部位</th>
                                <th className="border px-4 py-2">項目</th>
                                <th className="border px-4 py-2">タイプ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modality.map((item, index) => (
                                <tr key={index} className="border bg-gray-200 text-center">
                                    <td className="border px-4 py-2 font-bold">{item.ID}</td>
                                    <td className="border px-4 py-2">{item.body1}</td>
                                    <td className="border px-4 py-2">{item.body2}</td>
                                    <td className="border px-4 py-2">{item.contrast}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="text-white text-2xl mt-10">検査スケジュール</div>
                <div className="w-full text-center">
                    <table className="w-8/12 table-auto border-collapse border">
                        <thead>
                            <tr className="border">
                                <th className="border px-4 py-2">時刻</th>
                                <th className="border px-4 py-2">内容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border bg-gray-200 text-center">
                                <td className="border px-4 py-2">{getReceptionDateTime()}</td>
                                <td className="border px-4 py-2">受付時刻</td>
                            </tr>
                            {hasIv && ['PET-CT_1', 'PET-CT_2'].includes(modality[0].ID) ?
                                <tr className="border bg-gray-200 text-center">
                                    <td className="border px-4 py-2">{convertDate2Time(ivStart)} ~ {convertDate2Time(ivEnd)}</td>
                                    <td className="border px-4 py-2">IV検査</td>
                                </tr>
                                : <></>}
                            <tr className="border bg-gray-200 text-center">
                                <td className="border px-4 py-2">{getStartTime(0)} ~ {getEndTime(0)}</td>
                                <td className="border px-4 py-2">{trimPET(modality[0].ID)} 検査</td>
                            </tr>
                            {hasIv && modality && modality.length > 1 && modality[1].ID && ['PET-CT_1', 'PET-CT_2'].includes(modality[1].ID) ?
                                <tr className="border bg-gray-200 text-center">
                                    <td className="border px-4 py-2">{convertDate2Time(ivStart)} ~ {convertDate2Time(ivEnd)}</td>
                                    <td className="border px-4 py-2">IV検査</td>
                                </tr>
                                : <></>}
                            {modality.length === 2 ?
                                <tr className="border bg-gray-200 text-center">
                                    <td className="border px-4 py-2">{getStartTime(1)} ~ {getEndTime(1)}</td>
                                    <td className="border px-4 py-2">{trimPET(modality[1].ID)} 検査</td>
                                </tr>
                                : <></>}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="text-white text-2xl mt-10">患者情報登録</div>
            <FormTmpPatients
                setPatientKana={setPatientKana}
            />

            <p className="mt-5 text-center text-white text-1xl">予約内容をご確認ください</p>
            <div className="flex justify-center">
                <button name="close" className={ButtonClass} onClick={insertBooking}>予約する</button>
                <button name="close" className={LightGrayButtonClass} onClick={resetStates}>閉じる</button>
            </div>

        </Modal>
    </>

}